import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Swiper, { Pagination, Autoplay, EffectFade, Navigation } from 'swiper';
import 'swiper/css/autoplay';	
import 'swiper/css/effect-cards';	

gsap.registerPlugin(ScrollTrigger)

function desktopStackingCards() {
  const stackingCardsBlock = document.querySelector(
    '[data-name="stacking-cards-container"]'
  )
  if (stackingCardsBlock) {
    const stackingCard = stackingCardsBlock.querySelectorAll(
      '[data-name="stacking-card"]'
    )

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: stackingCardsBlock,
        pin: true,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        stagger: 2,
      },
    })
    

    const stackingCardReverse = [...stackingCard].reverse()
    stackingCardReverse.pop()

    stackingCardReverse.forEach((card) => {
      tl.addLabel('start')
        .from(card, {
          translateY: '0',
          autoAlpha: 1,
          duration: 0.5,
        })
        .to(card, {
          translateY: '-100%',
          rotate: '-30deg',
          duration: 0.5,
        })
        .to(
          card,
          {
            autoAlpha: 0,
            duration: 0.5,
          },
          '-=0.25'
        )
    })
  }
}

function mobileStackingCards() {
  var sliderElement = document.querySelector('.js-card-mobile-slider');
  sliderElement.classList.add('swiper');  
  var swiperWrapper = sliderElement.children;
  var swiperWrapper = document.querySelector('.js-card-mobile-slider .wrapper');
  swiperWrapper.classList.add('swiper-wrapper')
  
  const cardsSlider = new Swiper('.js-card-mobile-slider', {
    modules: [Pagination, Autoplay, EffectFade, Navigation],
    loop: true,
    spaceBetween: 20,
    rotate: true,
    slideShadows: true,
    draggable: true,
    allowTouchMove: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
    },
    speed: 600,    
    slidesPerView: 1,    
  });
}


function stackingCards() {
  if(document.querySelector('[data-name="stacking-cards-container"]')) {
    if(window.innerWidth >= 1024) {
      desktopStackingCards();
      console.log('desktop')
    } else {
      mobileStackingCards();
    }
  } else {
    return;
  }
}


export default stackingCards
